<template>
    <template v-if="loading">
        <Loading />
    </template>

    <template v-else-if="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
    </template>

    <template v-else>
        <div class="performance-list">
            <template v-for="group in groupedEvents" :key="group.month">
                <h3 class="performance-list__month-title">{{ group.monthName }}</h3>
                <Performance
                    v-for="performance in group.performances"
                    :key="performance.id"
                    :performance="performance"
                />
            </template>
        </div>
    </template>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import { getPerformances } from '../../services/inventory';
import Performance from './Performance.vue';

const props = defineProps({
    eventId: {
        type: String,
        required: true,
    }
});

const events = ref([]);
const loading = ref(true);
const errorMessage = ref(null);

const groupedEvents = computed(() => {
    const monthMap = new Map();
    for (const perf of events.value) {
        const key = perf._auxiliary?.group_by_month ?? '';
        if (!monthMap.has(key)) {
            monthMap.set(key, {
                month: key,
                monthName: perf._auxiliary?.group_name_month ?? '',
                performances: [],
            });
        }
        monthMap.get(key).performances.push(perf);
    }
    return [...monthMap.values()];
});

onBeforeMount(async () => {
    try {
        events.value = await getPerformances()
            .then(perfs => perfs.filter(perf => perf.event.id === props.eventId));
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Something has gone wrong, please try again later.';
        events.value = [];
    } finally {
        loading.value = false;
    }
});
</script>
